import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import usePageMeta from "@/hooks/usePageMeta";
import HeroSection from "./components/HeroSection";
import CategoryEntry from "./components/CategoryEntry";
import LatestGrid from "./components/LatestGrid";
import ReviewSpotlight from "./components/ReviewSpotlight";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  usePageMeta({
    title: "人兽影视网 - 最新电影电视剧资讯与剧情介绍",
    description:
      "人兽影视网提供丰富的电影和电视剧资讯，涵盖剧情介绍、演员信息和影评分析，满足影视爱好者的多样需求。",
    keywords: "人兽,影视,电影,电视剧,剧情介绍,影评,演员信息,影视资讯",
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryEntry />
        <LatestGrid />
        <ReviewSpotlight />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}